/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_G_WebInputs */

const tr_landing_integrations_g_web = /** @type {(inputs: Landing_Integrations_G_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web mağazanız`)
};

const en_landing_integrations_g_web = /** @type {(inputs: Landing_Integrations_G_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your web store`)
};

const de_landing_integrations_g_web = /** @type {(inputs: Landing_Integrations_G_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Webshop`)
};

const ru_landing_integrations_g_web = /** @type {(inputs: Landing_Integrations_G_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш интернет-магазин`)
};

/**
* | output |
* | --- |
* | "Your web store" |
*
* @param {Landing_Integrations_G_WebInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_g_web = /** @type {((inputs?: Landing_Integrations_G_WebInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_G_WebInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_g_web(inputs)
	if (locale === "de") return de_landing_integrations_g_web(inputs)
	if (locale === "ru") return ru_landing_integrations_g_web(inputs)
	return tr_landing_integrations_g_web(inputs)
});